function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const AchIcon = _ref => {
  let {
    size,
    bg,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 780 500",
    __css: {
      width: 'auto',
      height: rem(16),
      verticalAlign: 'middle'
    }
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#047BB7",
    strokeWidth: "30",
    d: "M53 13.8h674c21.3 0 38.5 16.9 38.5 37.9v397.5c0 20.9-17.2 37.9-38.5 37.9H53c-21.3 0-38.5-16.9-38.5-37.9V51.7C14.4 30.8 31.7 13.8 53 13.8h0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#047BB7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.7 312.3h-65.6l-11.5 37.1h-51.2l72.8-198.6h45l73.4 198.6h-51.4l-11.5-37.1zm-54.1-37h42.7l-21.4-68.9-21.3 68.9zM474.9 282.1c-.6 13.8-4.4 26-11.2 36.6-6.8 10.6-16.4 18.8-28.7 24.6-12.3 5.8-26.4 8.7-42.2 8.7-26.1 0-46.6-8.5-61.7-25.5-15-17-22.5-41-22.5-72v-9.8c0-19.5 3.4-36.5 10.2-51.1 6.8-14.6 16.5-25.9 29.3-33.8 12.7-8 27.5-11.9 44.2-11.9 24.1 0 43.5 6.3 58.1 19 14.6 12.7 23 30.2 25 52.4h-47.7c-.4-12.1-3.4-20.8-9.1-26.1-5.7-5.3-14.5-7.9-26.2-7.9-11.9 0-20.6 4.5-26.2 13.4-5.5 8.9-8.5 23.1-8.7 42.7v14c0 21.2 2.7 36.3 8 45.4 5.3 9.1 14.5 13.6 27.5 13.6 11 0 19.4-2.6 25.2-7.8 5.8-5.2 8.9-13.4 9.3-24.7h47.4zM663.5 349.4h-47.6v-82.9h-70.5v82.9h-47.9V150.8h47.9v78.8h70.5v-78.8h47.6v198.6z"
  })));
};
AchIcon.defaultProps = {
  size: 16,
  bg: 'currentColor'
};
export default AchIcon;